<template>
  <div>
    <slot name="modal">     
      <div class="md-layout">
        <div class="md-layout-item">
          <md-dialog-alert
            :md-active.sync="showModal"
            :md-content="this.getModalText"
            md-confirm-text="Close"
          />
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "generic-modal",
  computed: {
    ...mapGetters({
      getShowModal: "showGenericModal",
      getModalText: "genericModalText",
    }),
    showModal: {
      get() {
        return this.getShowModal;
      },
      set(newValue) {
        return this.$store.commit("SET_SHOW_GENERIC_MODAL", newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
